<template>
  <base-select
    v-bind="$attrs"
    :value="$props.value"
    :options="options"
    name="User Type"
    label="User Type"
    placeholder="Select Role"
    rules="required"
    @input="(value) => $emit('input', value)"
  ></base-select>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'UserRoleSelect',
  props: {
    value: String
  },
  emits: ['input'],
  setup() {
    const options = [
      { value: 'Employee', text: 'Employee' },
      { value: 'Corporate Admin', text: 'Company Admin' }
    ]

    return {
      options
    }
  }
})
</script>
